import { createContext, useContext, useEffect, useState } from "react";
import * as en from "./en";
import * as nl from "./nl";

const BUNDLES = { en, nl };
const LangContext = createContext(null);

const DUTCH_TIMEZONES = ["Europe/Amsterdam", "Europe/Brussels"];

// Reliable, offline signal that a visitor is Dutch/Belgian (browser language or timezone).
function localeSuggestsDutch() {
  try {
    const langs = navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language];
    if (langs.some((l) => l && l.toLowerCase().startsWith("nl"))) return true;
    const tz = Intl.DateTimeFormat().resolvedOptions().timeZone || "";
    if (DUTCH_TIMEZONES.includes(tz)) return true;
  } catch (e) {}
  return false;
}

function initialLang() {
  try {
    const param = new URLSearchParams(window.location.search).get("lang");
    if (param === "en" || param === "nl") return param;
  } catch (e) {}
  const stored = typeof localStorage !== "undefined" && localStorage.getItem("odn_lang");
  if (stored === "en" || stored === "nl") return stored;
  if (localeSuggestsDutch()) return "nl";
  return "en";
}

export const LanguageProvider = ({ children }) => {
  const [lang, setLangState] = useState(initialLang);

  const setLang = (l) => {
    setLangState(l);
    try {
      localStorage.setItem("odn_lang", l);
    } catch (e) {}
  };

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const bundle = BUNDLES[lang];
  const value = { lang, setLang, t: bundle.ui, c: bundle.data };
  return <LangContext.Provider value={value}>{children}</LangContext.Provider>;
};

export const useI18n = () => {
  const ctx = useContext(LangContext);
  if (!ctx) throw new Error("useI18n must be used within LanguageProvider");
  return ctx;
};
